export async function request<T>(url: string, options: object): Promise<T> {
  const response = await fetch(url, options);
  if (response.status === 200) {
    return response.json() as Promise<T>;
  }

  return Promise.resolve({
    message: response.statusText,
    success: false,
  }) as Promise<T>;
}

export default request;
